import { StyleSheet, Dimensions } from 'react-native';

import { Metrics } from '@vfgroup-oneplatform/foundation/Components/Themes';

const textContainerHeight = 142;
const { height, width } = Dimensions.get('window');

export default StyleSheet.create({
  cardContainer: {
    flexDirection: 'row',
  },
  containerStyle: theme => ({
    backgroundColor: theme.colors.transparent,
    flex: 1,
    height: 182,
    marginRight: Metrics.galleryCardMargin,
    width: Metrics.galleryCardWidth,
  }),
  loadingCard: theme => ({
    backgroundColor: theme.colors.backgroundColorThree,
    borderRadius: 6,
    height: textContainerHeight,
    marginTop: height * 0.01,
    paddingTop: 20,
    justifyContent: 'center',
    alignItems: 'center',
  }),
  firstLineContainer: {
    width: width * 0.27,
  },
  secondLineContainer: {
    width: width * 0.22,
  },
  circleContainer: {
    alignItems: 'center',
    width: width * 0.12,
  },
});
